// extracted by mini-css-extract-plugin
module.exports = {"checkBoxWrap":"checkBox_checkBoxWrap__3HnHw","checkboxInput":"checkBox_checkboxInput__1Aghq","checkboxlabel":"checkBox_checkboxlabel__7Rmx6"};